import { useContext } from "react";

import UseModalContext from "./context";
import { UseModalProviderContext } from "./types";

const useModal = (): UseModalProviderContext => useContext(UseModalContext);

export default useModal;
